import React, { forwardRef } from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const ArrowSortAsc = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon {...props} ref={ref} viewBox="0 0 24 24">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5941 5.25322L16.7531 9.52739C17.2808 10.0697 16.9068 11 16.1589 11H7.84107C7.09316 11 6.71921 10.0697 7.24694 9.52739L11.4094 5.25322C11.7344 4.91559 12.2656 4.91559 12.5941 5.25322ZM15.8177 14L12.0017 17.9217L8.18253 14H15.8177ZM12.5941 18.7468C12.2656 19.0844 11.7344 19.0844 11.4094 18.7468L7.24694 14.4726C6.71921 13.9303 7.09316 13 7.84107 13H16.1589C16.9068 13 17.2808 13.9303 16.7531 14.4726L12.5941 18.7468Z"
    />
  </SvgIcon>
));

ArrowSortAsc.displayName = 'ArrowSortAsc';

export default ArrowSortAsc;
